import { render, staticRenderFns } from "./PropertiesListView.vue?vue&type=template&id=94d1c17c&scoped=true&"
import script from "./PropertiesListView.vue?vue&type=script&lang=js&"
export * from "./PropertiesListView.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesListView.vue?vue&type=style&index=0&id=94d1c17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d1c17c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VSheet})
